<template>
  <div>
    <div v-if="!loading && issuesCount.length">
      <apexcharts :options="issuesOptions" :series="issuesCount"></apexcharts>
    </div>
    <div v-else-if="!loading">
      <p>No data available</p>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ProductInsights',
  components: {
    apexcharts: VueApexCharts
  },
  props: ['brandId', 'incrementalTripsData', 'picklPurchasesData'],
  data: function () {
    return {
      issuesCount: [],
      secondQuestion: [],
      ShoppingInshgits: [],
      keys: [],
      loading: true,
      issuesOptions: {
        chart: {
          title: {
            text: 'Activities with Issues Summary'
          },
          type: 'pie'
        },
        labels: []
      },
      series: []
    }
  },
  mounted () {
    // Set loading to false if incrementalTripsData is not provided or empty
    if (!this.incrementalTripsData || !this.incrementalTripsData.length) {
      this.loading = false
    }
  },
  watch: {
    incrementalTripsData (newData) {
      if (newData && newData.length) {
        this.issuesOptions.labels = []
        this.issuesCount = []

        newData.forEach((q) => {
          this.issuesOptions.labels.push(q.answer)
          this.issuesCount.push(q.answer_count)
        })
      }

      this.loading = false
    }
  }
}
</script>
